import { useSearchParams } from "react-router-dom"
import { useEffect } from "react"
import { langStore } from "@/stores/lang-store"
import { toast } from "sonner"
import { statsBundle } from "./stats-const"
import { statsStore } from "./stats-store"
import HeatmapView from "./_components/heatmap/heatmap-view"
import SummaryView from "./_components/summary/summary-view"

const StatsPage = () => {
  const [searchParams] = useSearchParams()
  const resource = searchParams.get("resource")
  const startDate = searchParams.get("start_date") ?? ""
  const endDate = searchParams.get("end_date") ?? ""

  const { lang } = langStore()

  useEffect(() => {
    if (!resource || !startDate || !endDate) return

    const toastId = toast.loading(statsBundle.load.loading[lang])

    const action = async () => {
      try {
        const finished = await statsStore.getState().apiGetStats({
          start_date: startDate,
          end_date: endDate,
          resource
        })

        if (!finished) {
          toast.error(statsBundle.load.failed[lang])
        }
      } catch (error) {
        console.error(error)
        toast.error(statsBundle.load.failed[lang])
      } finally {
        toast.dismiss(toastId)
      }
    }

    action()

    return () => {
      toast.dismiss(toastId)
      statsStore.getState().reset()
    }
  }, [resource, startDate, endDate, lang])

  return (
    <div className="w-full h-full">
      <SummaryView />
      <HeatmapView />
    </div>
  )
}

export default StatsPage
